import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";

import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/pages/AdminLayout";
import Overview from "@/pages/Overview";
import TVsPage from "@/pages/TVsPage";
import PlaylistsPage from "@/pages/PlaylistsPage";
import ContentLibraryPage from "@/pages/ContentLibraryPage";
import NOCPage from "@/pages/NOCPage";
import AnalyticsPage from "@/pages/AnalyticsPage";
import SchedulesCalendarPage from "@/pages/SchedulesCalendarPage";
import VaultPage from "@/pages/VaultPage";
import FlyerStudioPage from "@/pages/FlyerStudioPage";
import AccountsPage from "@/pages/AccountsPage";
import TVLogin from "@/pages/TVLogin";
import TVPlayer from "@/pages/TVPlayer";
import Landing from "@/pages/Landing";
import DownloadAppPage from "@/pages/DownloadAppPage";
import VideoWallPage from "@/pages/VideoWallPage";

function ProtectedAdmin({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-500" data-testid="auth-loading">
        Loading...
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<AdminLogin />} />
            <Route path="/tv-login" element={<TVLogin />} />
            <Route path="/tv" element={<TVPlayer />} />
            <Route path="/download" element={<DownloadAppPage />} />
            <Route path="/apk" element={<DownloadAppPage />} />
            <Route path="/tv-app" element={<DownloadAppPage />} />
            <Route
              path="/app"
              element={
                <ProtectedAdmin>
                  <AdminLayout />
                </ProtectedAdmin>
              }
            >
              <Route index element={<Overview />} />
              <Route path="tvs" element={<TVsPage />} />
              <Route path="video-wall" element={<VideoWallPage />} />
              <Route path="noc" element={<NOCPage />} />
              <Route path="playlists" element={<PlaylistsPage />} />
              <Route path="calendar" element={<SchedulesCalendarPage />} />
              <Route path="content" element={<ContentLibraryPage />} />
              <Route path="analytics" element={<AnalyticsPage />} />
              <Route path="vault" element={<VaultPage />} />
              <Route path="flyers" element={<FlyerStudioPage />} />
              <Route path="accounts" element={<AccountsPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
